<template>
  <section class="app-solicitacao">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Fale com o Presidente</v-card-title>
            <v-card-text class="app-card-content">
              <v-form
                ref="form"
                v-model="form.valid"
                lazy-validation
                @submit.prevent="onSubmit"
                v-if="!sended"
              >
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.userName"
                      placeholder="Digite seu nome"
                      label="Nome *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="6" :sm="6" :xs="6" cols="12">
                    <v-text-field
                      v-model="form.email"
                      placeholder="Digite seu email"
                      label="Email *"
                      :rules="[rules.required, rules.email]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="6" :sm="6" :xs="6" cols="12">
                    <v-text-field
                      v-model="form.phone"
                      placeholder="Digite seu telefone"
                      label="Telefone *"
                      :rules="[rules.required]"
                      filled
                      v-mask="'(##) #####-####'"
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <label class="ml-1">
                      <strong>Especificação da Reclamação / Sugestão / Elogio</strong>
                    </label>
                    <v-radio-group
                      v-model="form.sugestion"
                      @change="verifyOuthersFields($event)"
                      :rules="[rules.required]"
                    >
                      <v-row justify="space-around">
                        <v-radio
                          v-for="area in areas"
                          :key="area.key"
                          :label="`${area.name}`"
                          :value="area.name"
                          class="mx-1"
                        ></v-radio>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12" v-if="form.sugestion === 'Outros'">
                    <v-text-field
                      v-model="form.sugestionOuther"
                      placeholder="Digite outros"
                      label="Outros *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-textarea
                      rounded
                      filled
                      dense
                      v-model="form.observation"
                      :label="'Crítica/Sugestão/Elogios *'"
                      :placeholder="'Digite sua observação'"
                      :rules="[rules.required]"
                    ></v-textarea>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input v-model="form.recaptcha" :rules="[rules.required]"></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit">Enviar Mensagem</v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
              </div>
              <div class="success-send" v-if="sended">
                <v-icon :size="100" color="green">check_circle_outline</v-icon>
                <h3>O presidente agradece sua mensagem.</h3>
                <h4>Em breve entrará em contato.</h4>
                <v-btn depressed color="primary" @click.prevent.stop="reset()">Nova Mensagem</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";
import EvaluationService from "@/services/evaluation.service";
import { delay } from "rxjs/operators";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";

export default {
  components: {
    VueRecaptcha
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Fale com Presidente - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      sended: false,
      areas: [
        { key: "energia_eletrica", name: "Energia Elétrica" },
        { key: "transporte", name: "Transporte" },
        { key: "ouvidoria", name: "Ouvidoria" },
        { key: "gas_canalizado", name: "Gás Canalizado" },
        { key: "outros", name: "Outros" }
      ],
      form: {
        userName: null,
        email: null,
        phone: null,
        sugestion: null,
        sugestionOuther: null,
        observation: null,
        recaptcha: null
      },
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido.";
        },
        required: value => !!value || "Esse campo deve ser preenchido"
      }
    };
  },
  methods: {
    reset() {
      this.sended = false;
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        EvaluationService.create(this.form)
          .pipe(delay(1000))
          .subscribe(
            res => {
              this.$refs.form.reset();
              this.sended = true;
              this.isLoading = false;
            },
            error => {
              this.$refs.recaptcha.reset();
              this.form.recaptcha = null;
              this.isLoading = false;
            }
          );
      }
    },
    verifyOuthersFields(value) {
      if (value !== "Outros") {
        this.form.sugestionOuther = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  &-card {
    &-title {
      margin-bottom: 0px !important;
    }
    &-content {
      position: relative;
      .loading {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        text-align: center;
        .v-progress-circular {
          margin: auto;
        }
      }
      .success-send {
        padding: 40px;
        text-align: center;
        h3 {
          font-weight: 400 !important;
        }
        h1 {
          font-weight: 900 !important;
          margin: 0px 0px 25px 0px;
        }
      }
    }
  }
}
</style>
